import { makeVar } from '@apollo/client';
export const productUpdatesReactiveVar = makeVar(new Map());